module.exports = __webpack_public_path__ + "img/clipboard2.dae4e396.png";